export default (value: any) => {
    switch (value) {
      case 1: return 'Not Sent';
      case 2: return 'Sending';
      case 3: return 'Sent';
      case 4: return 'Failed';
      default: return 'Unknown';
    }
  };